module.exports = __webpack_public_path__ + "static/Salvation-5ab1485fc50110c0718c498132c700b4.jpg";